import React, { useState, useEffect, useRef } from "react";
import Header from "../component/Header";
import Sidebar from '../component/Sidebar';
import '../css/sidebar.css';
import { NavLink } from 'react-router-dom';
import { Tooltip, Whisper } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import IconEdit from '../images/iconEdit.svg';
import "../css/style_rollover.css"
// import ArrowTrendUp from "../images/arrow-trend-up.svg";
import { ReactComponent as ArrowTrendUp } from "../images/arrow-trend-up.svg";
import { ReactComponent as ArrowTrendDown } from "../images/arrow-trend-down.svg";
import { Placeholder } from 'rsuite';
import { toast } from "react-toastify";
import { getCurrentLanguage, t } from "../i18n";
import angelOneWebSocketService, {
  getAngelExchangeTypeFromHolding,
} from "../services/angelOneWebSocketService";

const getStoredBrokerType = () => {
  const sharedData = JSON.parse(localStorage.getItem("sharedData") || "null");
  return String(
    sharedData?.broker_type || localStorage.getItem("broker_type") || "",
  ).toLowerCase();
};

function Rollover(props) {
  return <RolloverContent {...props} />;
}

function RolloverContent(props) {
  const [activeTab, setActiveTab] = useState('All');
  const [currentLanguage, setCurrentLanguage] = useState(getCurrentLanguage());
  const tr = (key) => t(key, currentLanguage);
  const [isLoading, setIsLoading] = useState(true);


  const sharedData = JSON.parse(localStorage.getItem("sharedData") || "null");
  const rolloverBrokerType = String(
    sharedData?.broker_type || localStorage.getItem("broker_type") || "5paisa"
  ).toLowerCase();
  const isFivePaisaBroker = rolloverBrokerType === "5paisa";

  const [searchTerm, setSearchTerm] = useState('');
  const [stocks, setStocks] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [viewMode, setViewMode] = useState("grid");
  const containerRef = useRef(null);
  const [commodity, setCommodity] = useState([]);
  const [backupCommodity, setBackupCommodity] = useState([])

  const [connected, setConnected] = useState(false);
  const heartbeatIntervalRef = useRef(null);
  const connectionMonitorRef = useRef(null);
  const subscribedCommodityScripcodesRef = useRef([]);

  const subscribedStocksRef = useRef([]);
  const angelSearchPriceUnsubRef = useRef(null);
  const angelSearchErrorUnsubRef = useRef(null);
  const angelSearchSubscriptionsRef = useRef([]);
  const angelRolloverSubscriptionsRef = useRef([]);


  const [ws, setWs] = useState(null);
  const wsRef = useRef(null);

  // Live price caches
  // const livePriceCache = useRef({}); 
  // const liveDiffCache = useRef({});
  // const liveChangePercentageCache = useRef({});

  // // Trigger re-render for live price updates
  // const [liveUpdateTrigger, setLiveUpdateTrigger] = useState(0);
  // Live price state (using state instead of refs for automatic re-renders)
  const [livePrices, setLivePrices] = useState({});

  const [rolloverDifference, setRolloverDifference] = useState("");
  const [truncateOrderId, setTruncateOrderId] = useState("");

  // State to store the item being edited
  const [editingItem, setEditingItem] = useState(null);
  const [updatedDifference, setUpdatedDifference] = useState("");


  const tabs = [tr("all"), tr("buy"), tr("sell"), tr("differenceCurrent")];

  class BaseRolloverAdapter {
    constructor(brokerType = "") {
      this.brokerType = String(brokerType || "").toLowerCase();
    }

    stringOrDefault = (value, fallback = "") =>
      value === null || value === undefined || value === "" ? fallback : String(value);

    numberOrZero = (value) => {
      const num = Number(value);
      return Number.isFinite(num) ? num : 0;
    };

    getHeaders = () => ({ "Content-Type": "application/json" });
    getListUrl = () => "";
    getSearchUrl = () => "";
    getAddUrl = () => "";
    getUpdateUrl = () => "";
    getDeleteUrl = () => "";
    // getNotifyUrl = () => "https://beta.infomanav.in/keep/zerodhaAPI/api.php?xAction=notifyCommodityRollOver";

    buildListPayload = (userId) => ({ userId, broker_type: this.brokerType });
    buildSearchPayload = (searchTerm) => ({ Name: searchTerm, broker_type: this.brokerType });
    buildDeletePayload = (rolloverId) => ({ RolloverId: rolloverId, broker_type: this.brokerType });
    buildUpdatePayload = (rolloverId, difference) => ({
      RolloverId: rolloverId,
      difference,
      broker_type: this.brokerType,
    });
    buildAddPayload = ({ userId, selectedBuy, selectedSell, difference }) => ({
      user_id: userId,
      broker_type: this.brokerType,
      sellStockSymbol: this.stringOrDefault(selectedSell?.Name),
      sellStockName: this.stringOrDefault(selectedSell?.FullName),
      sellStockScripcode: this.numberOrZero(selectedSell?.Scripcode),
      buyStockSymbol: this.stringOrDefault(selectedBuy?.Name),
      buyStockName: this.stringOrDefault(selectedBuy?.FullName),
      buyStockScripcode: this.numberOrZero(selectedBuy?.Scripcode),
      difference,
    });
    buildNotifyPayload = ({ item, currentDifference, setDifference }) => ({
      id: item?.id,
      user_id: item?.user_id,
      symbol_1: item?.symbol_1,
      symbol_2: item?.symbol_2,
      currentDifference,
      setDifference,
    });

    normalizeListResponse = (apiResponse = {}) =>
      Array.isArray(apiResponse) ? apiResponse : [];

    normalizeSearchResponse = (apiResponse = {}) =>
      Array.isArray(apiResponse) ? apiResponse : [];

    normalizeMutationResponse = (apiResponse = {}) => apiResponse?.data || apiResponse || {};
  }

  class FivePaisaRolloverAdapter extends BaseRolloverAdapter {
    getListUrl = () => "https://pmsapi.infomanav.in/api/v1/rollover/list";
    getSearchUrl = () => "https://pmsapi.infomanav.in/api/v1/rollover/search";
    getAddUrl = () => "https://pmsapi.infomanav.in/api/v1/rollover/add";
    getUpdateUrl = () => "https://pmsapi.infomanav.in/api/v1/rollover/update";
    getDeleteUrl = () => "https://pmsapi.infomanav.in/api/v1/rollover/delete";
    getNotifyUrl = () => "https://pmsapi.infomanav.in/api/v1/rollover/notify"; 
  

    buildNotifyPayload = ({ item, currentDifference, setDifference }) => ({
      RolloverId: this.numberOrZero(item?.id ?? item?.RolloverId),
      broker_type: this.stringOrDefault(item?.broker_type, this.brokerType),
      currentDifference,
      setDifference,
      sellStockSymbol_1: this.stringOrDefault(item?.sellStockSymbol, item?.symbol_2),
      buyStockSymbol_2: this.stringOrDefault(item?.buyStockSymbol, item?.symbol_1),
      user_id: this.numberOrZero(item?.user_id),
    });

    normalizeListResponse = (apiResponse = {}) => {
      const apiData = apiResponse?.data || {};
      if (String(apiData?.status || "").toLowerCase() !== "success") return [];
      const rows = Array.isArray(apiData?.response) ? apiData.response : [];
      return rows.map((row = {}) => ({
        ...row,
        id: this.stringOrDefault(row?.RolloverId),
        user_id: this.stringOrDefault(row?.user_id),
        broker_type: this.stringOrDefault(row?.broker_type, this.brokerType),
        symbol_1: this.stringOrDefault(row?.buyStockSymbol),
        name_1: this.stringOrDefault(row?.buyStockName),
        scripcode_1: this.stringOrDefault(row?.buyStockScripcode),
        buy_sell_1: "Buy",
        symbol_2: this.stringOrDefault(row?.sellStockSymbol),
        name_2: this.stringOrDefault(row?.sellStockName),
        scripcode_2: this.stringOrDefault(row?.sellStockScripcode),
        buy_sell_2: "Sell",
        difference: this.stringOrDefault(row?.difference, "0"),
        isNotified: this.stringOrDefault(row?.isNotified, "0"),
      }));
    };

    normalizeSearchResponse = (apiResponse = {}) => {
      const apiData = apiResponse?.data || {};
      if (String(apiData?.status || "").toLowerCase() !== "success") return [];
      const rows = Array.isArray(apiData?.response) ? apiData.response : [];
      return rows.map((row = {}) => ({
        ...row,
        Scripcode: this.stringOrDefault(row?.ScripCode),
        Name: this.stringOrDefault(row?.Name),
        FullName: this.stringOrDefault(row?.FullName),
        Type: "MCX-Derivative",
      }));
    };
  }

  class AngelOneRolloverAdapter extends FivePaisaRolloverAdapter {
    normalizeListResponse = (apiResponse = {}) => {
      const apiData = apiResponse?.data || {};
      if (String(apiData?.status || "").toLowerCase() !== "success") return [];
      const rows = Array.isArray(apiData?.response) ? apiData.response : [];
      return rows.map((row = {}) => ({
        ...row,
        id: this.stringOrDefault(row?.RolloverId ?? row?.id),
        user_id: this.stringOrDefault(row?.user_id),
        broker_type: this.stringOrDefault(row?.broker_type, this.brokerType),
        symbol_1: this.stringOrDefault(row?.buyStockSymbol ?? row?.symbol_1),
        name_1: this.stringOrDefault(row?.buyStockName ?? row?.name_1),
        scripcode_1: this.stringOrDefault(row?.buyStockScripcode ?? row?.scripcode_1),
        buy_sell_1: "Buy",
        symbol_2: this.stringOrDefault(row?.sellStockSymbol ?? row?.symbol_2),
        name_2: this.stringOrDefault(row?.sellStockName ?? row?.name_2),
        scripcode_2: this.stringOrDefault(row?.sellStockScripcode ?? row?.scripcode_2),
        buy_sell_2: "Sell",
        difference: this.stringOrDefault(row?.difference, "0"),
        isNotified: this.stringOrDefault(row?.isNotified, "0"),
      }));
    };

    buildNotifyPayload = ({ item, currentDifference, setDifference }) => ({
      RolloverId: this.numberOrZero(item?.id ?? item?.RolloverId),
      broker_type: this.stringOrDefault(item?.broker_type, this.brokerType),
      currentDifference,
      setDifference,
      sellStockSymbol_1: this.stringOrDefault(item?.sellStockSymbol, item?.symbol_2),
      buyStockSymbol_2: this.stringOrDefault(item?.buyStockSymbol, item?.symbol_1),
      user_id: this.numberOrZero(item?.user_id),
    });

    normalizeSearchResponse = (apiResponse = {}) => {
      const apiData = apiResponse?.data || {};
      if (String(apiData?.status || "").toLowerCase() !== "success") return [];
      const rows = Array.isArray(apiData?.response) ? apiData.response : [];
      return rows.map((row = {}) => ({
        ...row,
        Exch: "M",
        ExchType: "D",
        Scripcode: this.stringOrDefault(row?.token),
        Name: this.stringOrDefault(row?.symbol),
        FullName: this.stringOrDefault(row?.name),
        Type: "MCX-Derivative",
      }));
    };
  }

  const getRolloverAdapter = (brokerType) => {
    const normalizedBrokerType = String(brokerType || "").toLowerCase();
    if (normalizedBrokerType === "5paisa") return new FivePaisaRolloverAdapter(normalizedBrokerType);
    if (normalizedBrokerType === "angelone") return new AngelOneRolloverAdapter(normalizedBrokerType);
    return new BaseRolloverAdapter(normalizedBrokerType);
  };

  const rolloverAdapter = getRolloverAdapter(rolloverBrokerType);


  // Define state for selections
  const [selectedBuy, setSelectedBuy] = useState(null);
  const [selectedSell, setSelectedSell] = useState(null);






  //----------------------------// useEffects //----------------------------//

  useEffect(() => {
    document.title = tr("rollOver");
  }, [currentLanguage]);

  useEffect(() => {
    const handleLanguageChange = (event) => {
      setCurrentLanguage(event?.detail?.language || getCurrentLanguage());
    };
    window.addEventListener("app-language-change", handleLanguageChange);
    return () => window.removeEventListener("app-language-change", handleLanguageChange);
  }, []);



  useEffect(() => {
    function handleClickOutside(event) {
      const modal = document.getElementById("RollOverDifference");

      if (
        containerRef.current &&
        !containerRef.current.contains(event.target) &&
        (!modal || !modal.contains(event.target)) // exclude modal
      ) {
        if (rolloverBrokerType === "angelone" && angelSearchSubscriptionsRef.current.length) {
          angelOneWebSocketService.unsubscribeMarketFeed(
            angelSearchSubscriptionsRef.current,
          );
          angelSearchSubscriptionsRef.current = [];
        }
        setShowDropdown(false);
        setStocks([]);
        setSearchTerm("");
        setSelectedBuy(null);
        setSelectedSell(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [rolloverBrokerType]);





  useEffect(() => {
    const initMCXData = async () => {
      console.log("✅✅Initializing MCX data fetch...");

      try {
        if (isFivePaisaBroker) {
          if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
            console.log("WebSocket not ready, connecting...");
            await handleConnectClick();
            console.log("WebSocket connected");
          }
        }

        const listUrl = rolloverAdapter.getListUrl();
        if (listUrl) {
          await fetchMCXData(sharedData.ID);
          console.log("MCX data fetched successfully");
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error fetching MCX data:", error);
        setIsLoading(false);
      }
    };

    initMCXData();
  }, [rolloverBrokerType]);





  // Add this useEffect after your other hooks (before the return statement)
  useEffect(() => {
    if (!commodity || commodity.length === 0) return;



    commodity.forEach((item) => {
      const livePrice1 = livePrices[Number(item.scripcode_1)]?.price ?? 0;
      const livePrice2 = livePrices[Number(item.scripcode_2)]?.price ?? 0;



      // Only proceed if both prices are available
      if (livePrice1 > 0 && livePrice2 > 0) {
        // Calculate current difference
        const currentDifference = livePrice1 - livePrice2;
        const setDifference = parseFloat(item.difference);



        // Check if set difference is greater than current difference
        if (setDifference > currentDifference) {
          // Check if not already notified
          if (item.isNotified !== "1") {
            // Immediately update local state to mark as notified
            setCommodity(prevCommodity =>
              prevCommodity.map(c =>
                c.id === item.id ? { ...c, isNotified: "1" } : c
              )
            );

            // Call API to notify user
            notifyCommodityRollOverAPI(item, currentDifference, setDifference);

            console.log(`Notification triggered for commodity pair ID: ${item.id}, Current Diff: ${currentDifference}, Set Diff: ${setDifference}`);
          }
        }
      }
    });
  }, [livePrices, commodity]);





  // 5paisa WebSocket connection monitor and cleanup (commodity table + search)
  useEffect(() => {
    if (!isFivePaisaBroker) {
      return undefined;
    }

    startConnectionMonitor();

    return () => {
      cleanupWebSocket();
    };
  }, [isFivePaisaBroker]);

  useEffect(() => {
    const modalElement = document.getElementById("UpdateDifferenceModal");
    if (!modalElement) return;

    const handleModalHidden = () => {
      setEditingItem(null);
      setUpdatedDifference("");
    };

    modalElement.addEventListener("hidden.bs.modal", handleModalHidden);
    return () => {
      modalElement.removeEventListener("hidden.bs.modal", handleModalHidden);
    };
  }, []);

  useEffect(() => {
    if (rolloverBrokerType !== "angelone") {
      return undefined;
    }

    angelSearchPriceUnsubRef.current = angelOneWebSocketService.onPrice((tick) => {
      if (tick) handleLivePriceUpdate(tick);
    });
    angelSearchErrorUnsubRef.current = angelOneWebSocketService.onError((error) => {
      console.error("AngelOne rollover search WebSocket error:", error);
    });

    angelOneWebSocketService.connect();

    return () => {
      angelSearchPriceUnsubRef.current?.();
      angelSearchErrorUnsubRef.current?.();
      angelSearchPriceUnsubRef.current = null;
      angelSearchErrorUnsubRef.current = null;

      if (angelSearchSubscriptionsRef.current.length) {
        angelOneWebSocketService.unsubscribeMarketFeed(
          angelSearchSubscriptionsRef.current,
        );
        angelSearchSubscriptionsRef.current = [];
      }

      if (angelRolloverSubscriptionsRef.current.length) {
        angelOneWebSocketService.unsubscribeMarketFeed(
          angelRolloverSubscriptionsRef.current,
        );
        angelRolloverSubscriptionsRef.current = [];
      }
    };
  }, [rolloverBrokerType]);











  //----------------------------// Functions //----------------------------//

  // Notification sound function
  const pingNotification = () => {
    try {
      const audio = new Audio('/sounds/notifications.mp3');
      audio.play().catch(error => {
        console.error('Failed to play notification sound:', error);
      });
    } catch (error) {
      console.error('Error creating audio:', error);
    }
  };


  // Common toast options
  const toastOptions = {
    position: "top-center",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light",
  };

  // Success toast function
  const showSuccessToast = (message) => {
    toast.success(message, {
      ...toastOptions,
      icon: "✅",
    });
    pingNotification()
  };

  // Error toast function
  const showErrorToast = (message) => {
    toast.error(message, {
      ...toastOptions,
      icon: "⚠️",
    });
    pingNotification()
  };

  const formatNumber = (num) => {
    if (num === null || num === undefined) return "-";
    const number = parseFloat(num);
    if (isNaN(number)) return "-";

    return number.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const closeDropdown = () => {
    if (rolloverBrokerType === "angelone" && angelSearchSubscriptionsRef.current.length) {
      angelOneWebSocketService.unsubscribeMarketFeed(
        angelSearchSubscriptionsRef.current,
      );
      angelSearchSubscriptionsRef.current = [];
    }
    setShowDropdown(false);
    setSelectedBuy(null);
    setSelectedSell(null);
    setStocks([]); // or however you clear stock list
    setSearchTerm('');
  };


  // Heartbeat function to keep connection alive
  const startHeartbeat = () => {
    if (heartbeatIntervalRef.current) {
      clearInterval(heartbeatIntervalRef.current);
    }

    // Send heartbeat every 30 seconds
    heartbeatIntervalRef.current = setInterval(() => {
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        try {
          // Send a simple ping message to keep connection alive
          wsRef.current.send(JSON.stringify({
            Method: "Heartbeat",
            Operation: "Ping",
            Timestamp: new Date().getTime()
          }));
          console.log("Heartbeat sent");
        } catch (error) {
          console.error("Error sending heartbeat:", error);
        }
      }
    }, 30000); // 30 seconds
  };



  const startConnectionMonitor = () => {
    if (connectionMonitorRef.current) {
      clearInterval(connectionMonitorRef.current);
    }

    connectionMonitorRef.current = setInterval(() => {
      const currentWs = wsRef.current;

      if (!currentWs || currentWs.readyState === WebSocket.CLOSED || currentWs.readyState === WebSocket.CLOSING) {
        console.log("🔴 WebSocket disconnected, attempting to reconnect and resubscribe...");
        reconnectAndResubscribe();
      } else if (currentWs.readyState === WebSocket.OPEN) {
        // Connection is healthy - log every 10 seconds to avoid spam
        const now = Date.now();
        if (!window.lastHealthLog || now - window.lastHealthLog > 10000) {
          console.log("✅ WebSocket connection healthy");
          window.lastHealthLog = now;
        }
      }
    }, 1000); // Check every 1 second
  };








  // Cleanup function
  const cleanupWebSocket = () => {
    if (heartbeatIntervalRef.current) {
      clearInterval(heartbeatIntervalRef.current);
      heartbeatIntervalRef.current = null;
    }

    if (connectionMonitorRef.current) {
      clearInterval(connectionMonitorRef.current);
      connectionMonitorRef.current = null;
    }

    if (wsRef.current) {
      wsRef.current.close();
      wsRef.current = null;
    }

    setConnected(false);
    setWs(null);
  };


  // Reconnect and resubscribe to all stocks
  // const reconnectAndResubscribe = async () => {
  //   try {
  //     console.log("🔄 Reconnecting WebSocket...");
  //     const newWs = await handleConnectClick();

  //     if (newWs && newWs.readyState === WebSocket.OPEN) {
  //       console.log("✅ WebSocket reconnected successfully");

  //       // Resubscribe to commodity data if available
  //       if (commodity && commodity.length > 0) {
  //         console.log("🔄 Resubscribing to commodity data...");
  //         const marketFeedData = [];
  //         const addedScripcodes = new Set();

  //         commodity.forEach((item) => {
  //           [item.scripcode_1, item.scripcode_2].forEach((code) => {
  //             if (code && !addedScripcodes.has(code)) {
  //               marketFeedData.push({
  //                 Exch: "M",
  //                 ExchType: "D",
  //                 ScripCode: Number(code),
  //               });
  //               addedScripcodes.add(code);
  //             }
  //           });
  //         });

  //         if (marketFeedData.length > 0) {
  //           const subscriptionMessage = {
  //             Method: "MarketFeedV3",
  //             Operation: "Subscribe",
  //             ClientCode: sharedData.ClientCode,
  //             MarketFeedData: marketFeedData,
  //           };

  //           newWs.send(JSON.stringify(subscriptionMessage));
  //           console.log(`✅ Resubscribed to ${marketFeedData.length} commodity scripcodes`);
  //         }
  //       }

  //       // Resubscribe to dropdown stocks if available
  //       if (stocks && stocks.length > 0) {
  //         console.log("🔄 Resubscribing to dropdown stocks...");
  //         const clientCode = sharedData?.ClientCode || "";
  //         subscribeStocksToWebSocket(stocks, clientCode);
  //       }

  //       console.log("✅ All resubscriptions completed");
  //     }
  //   } catch (error) {
  //     console.error("❌ Reconnection failed:", error);
  //   }
  // };
  // Reconnect and resubscribe to all stocks
  const reconnectAndResubscribe = async () => {
    if (!isFivePaisaBroker) {
      return;
    }

    try {
      console.log("🔄 Reconnecting WebSocket...");
      const newWs = await handleConnectClick();

      if (newWs && newWs.readyState === WebSocket.OPEN) {
        console.log("✅ WebSocket reconnected successfully");

        // Resubscribe to commodity data if available


        // Resubscribe to commodity data if available
        if (subscribedCommodityScripcodesRef.current && subscribedCommodityScripcodesRef.current.length > 0) {
          console.log("🔄 Resubscribing to commodity data...");

          const subscriptionMessage = {
            Method: "MarketFeedV3",
            Operation: "Subscribe",
            ClientCode: sharedData.ClientCode,
            MarketFeedData: subscribedCommodityScripcodesRef.current,
          };

          newWs.send(JSON.stringify(subscriptionMessage));
          console.log(`✅ Resubscribed to ${subscribedCommodityScripcodesRef.current.length} commodity scripcodes`);
        } else {
          console.log("⚠️ No commodity scripcodes to resubscribe");
        }


        // Resubscribe to dropdown stocks if previously subscribed
        if (subscribedStocksRef.current && subscribedStocksRef.current.length > 0) {
          console.log("🔄 Resubscribing to dropdown stocks...");
          const clientCode = sharedData?.ClientCode || "";
          await subscribeStocksToWebSocket(subscribedStocksRef.current, clientCode);
          console.log(`✅ Resubscribed to ${subscribedStocksRef.current.length} dropdown stocks`);
        }

        console.log("✅ All resubscriptions completed");
        console.log(`📊 Summary: ${subscribedCommodityScripcodesRef.current.length} commodity scripcodes, ${subscribedStocksRef.current.length} dropdown stocks resubscribed`);

      }
    } catch (error) {
      console.error("❌ Reconnection failed:", error);
    }
  };






  const computeCurrentDifference = (item) => {
    const price1 = livePrices[Number(item.scripcode_1)]?.price || 0;
    const price2 = livePrices[Number(item.scripcode_2)]?.price || 0;
    return (price1 && price2) ? (price1 - price2).toFixed(2) : "0.00";
  };




  // Function to call notification API
  const notifyCommodityRollOverAPI = async (item, currentDifference, setDifference) => {
    try {
      const response = await fetch(
        rolloverAdapter.getNotifyUrl(),
        {
          method: "POST",
          headers: rolloverAdapter.getHeaders(),
          body: JSON.stringify(
            rolloverAdapter.buildNotifyPayload({ item, currentDifference, setDifference })
          ),
        }
      );

      const rawData = await response.json();
      const data = rolloverAdapter.normalizeMutationResponse(rawData);

      if (data.status === "success") {
        showSuccessToast(
          `Email sent: ${item.symbol_1} vs ${item.symbol_2} - Notification dispatched!`
        );

        // Refresh the commodity data to get updated isNotified status
        setTimeout(() => {
          fetchMCXData(sharedData.ID);
        }, 3000);

        console.log(`✅ Email notification sent for commodity pair ID: ${item.id}`);
      } else {
        console.error(`❌ Notification API failed: ${data.message}`);
        showErrorToast(`Failed to send notification: ${data.message}`);
      }
    } catch (error) {
      console.error(`❌ API call failed:`, error);
      showErrorToast(tr("failedToSendNotificationTryAgain"));
    }
  };





  // Open modal and set item when edit button is clicked
  const fetchMCXData = async (userId) => {
    const url = rolloverAdapter.getListUrl();

    console.log("📉🚀 fetchMCXData called with userId:", userId);

    // Start loading
    // setIsLoading(true);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: rolloverAdapter.getHeaders(),
        body: JSON.stringify(rolloverAdapter.buildListPayload(userId)),
      });

      console.log("📉📡 API request sent, awaiting response...");

      const responseData = await response.json();
      console.log("📉📬 API response received:", responseData);
      const commodities = rolloverAdapter.normalizeListResponse(responseData);

      if (commodities.length === 0) {
        console.warn("📉No commodities found for this user.");
        setCommodity([]);
        setBackupCommodity([]);
        // setIsLoading(false); // Stop loading
        setTimeout(() => {
          setIsLoading(false); // Stop loading

        }, 1500);
        return;
      }

      console.log(`📉✅ Commodities received: ${commodities.length}`);

      setCommodity(commodities);
      setBackupCommodity(commodities);

      if (!isFivePaisaBroker) {
        if (rolloverBrokerType === "angelone") {
          // Subscribe to the rollover list tokens shown in this UI.
          // We subscribe both buy + sell scripcodes so the difference column updates live.
          const tokens = new Set();

          commodities.forEach((c) => {
            if (c?.scripcode_1) tokens.add(String(c.scripcode_1).trim());
            if (c?.scripcode_2) tokens.add(String(c.scripcode_2).trim());
          });

          const tokenList = Array.from(tokens);
          if (!tokenList.length) {
            setTimeout(() => setIsLoading(false), 1500);
            return;
          }

          // MCX futures go over exchangeType=5 in AngelOne smart stream.
          const exchangeType = getAngelExchangeTypeFromHolding({
            Exch: "M",
            ExchType: "D",
            ExchSeg: "MCX",
            InstrumentType: "FUTCOM",
          });

          const angelFeedItems = tokenList.map((token) => ({
            exchangeType,
            token,
          }));

          if (angelRolloverSubscriptionsRef.current.length) {
            angelOneWebSocketService.unsubscribeMarketFeed(
              angelRolloverSubscriptionsRef.current,
            );
            angelRolloverSubscriptionsRef.current = [];
          }

          angelOneWebSocketService.connect();
          angelOneWebSocketService.subscribeMarketFeed(angelFeedItems);
          angelRolloverSubscriptionsRef.current = angelFeedItems;

          setTimeout(() => setIsLoading(false), 1500);
          return;
        }

        // For any other broker types, we currently only support REST list without live prices.
        setTimeout(() => setIsLoading(false), 1500);
        return;
      }

      // Flatten scripcodes and remove duplicates
      const marketFeedData = [];
      const addedScripcodes = new Set();

      commodities.forEach((commodity, idx) => {
        console.log(`📉Processing commodity index ${idx}:`, commodity);
        [commodity.scripcode_1, commodity.scripcode_2].forEach((code) => {
          if (code && !addedScripcodes.has(code)) {
            marketFeedData.push({
              Exch: "M",
              ExchType: "D",
              ScripCode: Number(code),
            });
            addedScripcodes.add(code);
            console.log(`📉Added scripcode ${code} to subscription list.`);
          }
        });
      });

      console.log("📉Final marketFeedData for subscription:", marketFeedData);

      if (marketFeedData.length === 0) {
        console.warn("📉⚠️ No marketFeedData to subscribe.");
        // setIsLoading(false); // Stop loading
        setTimeout(() => {
          setIsLoading(false); // Stop loading
        }, 1500);
        return;
      }

      const subscriptionMessage = {
        Method: "MarketFeedV3",
        Operation: "Subscribe",
        ClientCode: sharedData.ClientCode,
        MarketFeedData: marketFeedData,
      };

      // Save commodity scripcodes for resubscription
      subscribedCommodityScripcodesRef.current = marketFeedData;
      console.log(`📦 Saved ${marketFeedData.length} commodity scripcodes for resubscription`);

      console.log("📨 Prepared subscription message:", subscriptionMessage);

      // Function to subscribe via WebSocket safely
      const sendSubscription = (webSocketInstance) => {
        if (webSocketInstance && webSocketInstance.readyState === WebSocket.OPEN) {
          console.log("📉Sending subscription via WebSocket...");
          webSocketInstance.send(JSON.stringify(subscriptionMessage));
          console.log("📉Subscription message sent successfully.");
          // setIsLoading(false); // Stop loading after successful subscription
          setTimeout(() => {
            setIsLoading(false); // Stop loading

          }, 1500);
        } else {
          console.warn("📉⚠️ Cannot send subscription, WebSocket not open.");
          // setIsLoading(false); // Stop loading even if failed
          setTimeout(() => {
            setIsLoading(false); // Stop loading

          }, 1500);
        }
      };

      // Check WebSocket state and reconnect if needed
      if (!ws || ws.readyState === WebSocket.CLOSED || ws.readyState === WebSocket.CLOSING) {
        console.log("📉WebSocket is closed or not initialized, reconnecting...");
        try {
          const newWs = await handleConnectClick(); // reconnect and get valid WebSocket
          console.log("📉WebSocket reconnected, sending subscription...");
          sendSubscription(newWs);
        } catch (error) {
          console.error("📉Failed to reconnect WebSocket:", error);
          // setIsLoading(false); // Stop loading on error
          setTimeout(() => {
            setIsLoading(false); // Stop loading

          }, 1500);
        }
      } else if (ws.readyState === WebSocket.OPEN) {
        console.log("📉WebSocket is open, sending subscription immediately.");
        sendSubscription(ws);
      } else if (ws.readyState === WebSocket.CONNECTING) {
        console.log("📉WebSocket connecting, waiting for 'open' event...");
        ws.addEventListener("open", () => sendSubscription(ws), { once: true });
      }
    } catch (error) {
      console.error("📉Error fetching commodity data:", error);
      setCommodity([]);
      setBackupCommodity([]);
      // setIsLoading(false); // Stop loading on error
      setTimeout(() => {
        setIsLoading(false); // Stop loading

      }, 1500);
    }
  };



  const handleTruncateOrder = async (id) => {
    if (!id) return;

    try {
      const res = await fetch(
        rolloverAdapter.getDeleteUrl(),
        {
          method: "POST",
          headers: rolloverAdapter.getHeaders(),
          body: JSON.stringify(rolloverAdapter.buildDeletePayload(id)),
        }
      );

      const result = await res.json();
      const apiData = rolloverAdapter.normalizeMutationResponse(result);
      console.log("Delete rollover response:", result);

      if (apiData.status === "success") {
        // toast({
        //   title: "Order deleted successfully.",
        //   status: "success",
        //   duration: 3000,
        //   isClosable: true,
        //   position: "top-right",
        // });
        showSuccessToast(apiData.message || tr("orderDeletedSuccessfully"))

        // Refresh commodity list from server
        fetchMCXData(sharedData.ID);
      } else {
        console.error("❌ Deletion failed:", apiData.message);
        // toast({
        //   title: "Error deleting order.",
        //   description: result.message || "Please try again.",
        //   status: "error",
        //   duration: 3000,
        //   isClosable: true,
        //   position: "top-right",
        // });
        showErrorToast(apiData.message || tr("errorDeletingOrder"))
      }
    } catch (error) {
      console.error("❌ Error truncating order:", error);
      // toast({
      //   title: "Error truncating order.",
      //   description: "There was an error processing your request. Please try again.",
      //   status: "error",
      //   duration: 3000,
      //   isClosable: true,
      //   position: "top-right",
      // });
      showErrorToast(tr("errorTruncatingOrder"))

    }
  };




  const handleEditDifference = (item) => {
    setEditingItem(item);
    setUpdatedDifference(item.difference);
  };

  // Function to submit updated difference
  const handleUpdateDifference = async () => {
    if (!updatedDifference) return;

    console.log("Updating difference:", updatedDifference, "for ID:", editingItem.id);

    try {
      const parsedDifference = Number(updatedDifference);
      if (Number.isNaN(parsedDifference)) return;

      const response = await fetch(
        rolloverAdapter.getUpdateUrl(),
        {
          method: "POST",
          headers: rolloverAdapter.getHeaders(),
          body: JSON.stringify(rolloverAdapter.buildUpdatePayload(editingItem.id, parsedDifference)),
        }
      );

      const data = await response.json();
      console.log("Difference update response:", data);
      const apiData = rolloverAdapter.normalizeMutationResponse(data);
      if (apiData.status !== "success") {
        showErrorToast(apiData.message || tr("failedToSubmitTryAgain"));
        return;
      }
      showSuccessToast(apiData.message || tr("recordUpdatedSuccessfully"));

      if (isFivePaisaBroker) {
        if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
          console.log("WebSocket not ready, connecting before refresh...");
          await handleConnectClick();
          console.log("WebSocket connected, refreshing MCX data");
        }
      }

      await fetchMCXData(sharedData.ID); // refresh data

      // Close modal
      const modal = window.bootstrap.Modal.getOrCreateInstance(
        document.getElementById("UpdateDifferenceModal")
      );
      modal.hide();
    } catch (error) {
      console.error("Error updating difference:", error);
    }
  };





  const handleSearchChange = async (e) => {
    const value = e.target.value;
    console.log("Search input changed:", value);
    setSearchTerm(value);

    if (value.length >= 3) {
      try {
        console.log("Fetching stocks for search term:", value);
        const response = await fetch(
          rolloverAdapter.getSearchUrl(),
          {
            method: "POST",
            headers: rolloverAdapter.getHeaders(),
            body: JSON.stringify(rolloverAdapter.buildSearchPayload(value)),
          }
        );
        const result = await response.json();
        const normalizedStocks = rolloverAdapter.normalizeSearchResponse(result);
        console.log("API response received:", result);

        if (normalizedStocks.length > 0) {
          console.log("Valid data received, updating stocks and showing dropdown");
          setStocks(normalizedStocks);
          setShowDropdown(true);

          if (rolloverBrokerType === "5paisa") {
            if (!connected) {
              console.log("WebSocket not connected, attempting to connect...");
              await handleConnectClick();
              console.log("WebSocket connection established");
            } else {
              console.log("WebSocket already connected");
            }

            const clientCode = JSON.parse(localStorage.getItem("sharedData"))?.ClientCode || "";
            console.log(`Subscribing to WebSocket with client code: ${clientCode}`);
            subscribeStocksToWebSocket(normalizedStocks, clientCode);
          } else if (rolloverBrokerType === "angelone") {
            const angelFeedItems = normalizedStocks
              .map((stock) => ({
                exchangeType: getAngelExchangeTypeFromHolding({
                  Exch: stock.Exch,
                  ExchType: stock.ExchType,
                  ExchSeg:
                    stock.Exch === "M"
                      ? "MCX"
                      : stock.Exch === "B"
                        ? "BSE"
                        : "NSE",
                  InstrumentType:
                    stock?.instrumenttype || stock?.InstrumentType || "FUTCOM",
                }),
                token: String(stock.Scripcode || stock.Token || "").trim(),
              }))
              .filter((item) => item.exchangeType && item.token);

            if (angelSearchSubscriptionsRef.current.length) {
              angelOneWebSocketService.unsubscribeMarketFeed(
                angelSearchSubscriptionsRef.current,
              );
              angelSearchSubscriptionsRef.current = [];
            }

            if (angelFeedItems.length > 0) {
              angelOneWebSocketService.connect();
              for (let i = 0; i < angelFeedItems.length; i += 50) {
                angelOneWebSocketService.subscribeMarketFeed(
                  angelFeedItems.slice(i, i + 50),
                );
              }
              angelSearchSubscriptionsRef.current = angelFeedItems;
            }
          } else {
            console.log(
              `Skipping search subscriptions for broker: ${rolloverBrokerType}`
            );
          }
        } else {
          console.log("No matching data found, clearing stocks and hiding dropdown");
          if (rolloverBrokerType === "angelone" && angelSearchSubscriptionsRef.current.length) {
            angelOneWebSocketService.unsubscribeMarketFeed(
              angelSearchSubscriptionsRef.current,
            );
            angelSearchSubscriptionsRef.current = [];
          }
          setStocks([]);
          setShowDropdown(false);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        if (rolloverBrokerType === "angelone" && angelSearchSubscriptionsRef.current.length) {
          angelOneWebSocketService.unsubscribeMarketFeed(
            angelSearchSubscriptionsRef.current,
          );
          angelSearchSubscriptionsRef.current = [];
        }
        setStocks([]);
        setShowDropdown(false);
      }
    } else {
      console.log("Input less than 3 characters, clearing stocks and hiding dropdown");
      if (rolloverBrokerType === "angelone" && angelSearchSubscriptionsRef.current.length) {
        angelOneWebSocketService.unsubscribeMarketFeed(
          angelSearchSubscriptionsRef.current,
        );
        angelSearchSubscriptionsRef.current = [];
      }
      setStocks([]);
      setShowDropdown(false);
    }
  };


  const subscribeStocksToWebSocket = async (stocksArray, clientCode) => {
    let wsCurrent = wsRef.current;
    console.log("Preparing to subscribe stocks to WebSocket...");

    if (!wsCurrent || wsCurrent.readyState !== WebSocket.OPEN) {
      console.warn("WebSocket not connected. Attempting to reconnect...");
      try {
        await handleConnectClick();
        wsCurrent = wsRef.current;
        if (!wsCurrent || wsCurrent.readyState !== WebSocket.OPEN) {
          console.error("Failed to reconnect WebSocket.");
          return;
        }
        console.log("WebSocket reconnected successfully.");
      } catch (error) {
        console.error("WebSocket reconnection failed:", error);
        return;
      }
    } else {
      console.log("WebSocket already connected and ready.");
    }

    const marketFeedData = stocksArray.map((stock) => ({
      Exch: stock.Exch?.charAt(0),
      ExchType: stock.ExchType?.charAt(0) === "C" ? "C" : "D",
      ScripCode: Number(stock.Scripcode),
    }));

    const message = {
      Method: "MarketFeedV3",
      Operation: "Subscribe",
      ClientCode: clientCode,
      MarketFeedData: marketFeedData,
    };

    try {
      console.log(`Sending subscription message for ${marketFeedData.length} stocks`);
      wsCurrent.send(JSON.stringify(message));
      subscribedStocksRef.current = stocksArray; // Track subscribed stocks
      console.log(`📦 Subscription message sent and ${stocksArray.length} stocks saved to subscribedStocksRef`);
      console.log("📦 Saved stocks:", subscribedStocksRef.current.map(s => s.Name).join(", "));

    } catch (error) {
      console.error("Error sending subscription message:", error);
    }



  };



  const setupWebSocketMessageHandler = (webSocket) => {
    console.log("Setting up WebSocket message handler...");

    webSocket.onmessage = (event) => {
      try {
        const receivedData = JSON.parse(event.data);
        console.log("📡 WebSocket RAW message received:", receivedData);

        // Handle both single objects and arrays
        if (Array.isArray(receivedData)) {
          receivedData.forEach(item => {
            if (item && item.Token) {
              console.log(`📡 Processing Token: ${item.Token}`);
              handleLivePriceUpdate(item);
            }
          });
        } else if (receivedData && receivedData.Token) {
          console.log(`📡 Processing single Token: ${receivedData.Token}`);
          handleLivePriceUpdate(receivedData);
        }
      } catch (error) {
        console.error("Error processing WebSocket message:", error);
      }
    };
  };





  const handleConnectClick = () => {
    return new Promise((resolve, reject) => {
      const saved = JSON.parse(localStorage.getItem("sharedData"));
      if (!saved?.accessToken || !saved?.ClientCode) {
        console.warn("Cannot connect WebSocket — missing token or client code.");
        reject("Missing token or client code");
        return;
      }

      console.log("Attempting WebSocket connection...");
      const webSocket = new WebSocket(
        `wss://openfeed.5paisa.com/Feeds/api/chat?Value1=${saved.accessToken}|${saved.ClientCode}`
      );

      webSocket.onopen = () => {
        console.log("WebSocket connected");
        setConnected(true);
        setWs(webSocket);
        wsRef.current = webSocket;
        setupWebSocketMessageHandler(webSocket);
        startHeartbeat();


        resolve(webSocket); // ✅ return the WebSocket instance
      };

      webSocket.onerror = (error) => {
        console.error("WebSocket error:", error);
        setConnected(false);
        reject(error);
      };
    });
  };


  // const handleLivePriceUpdate = (data) => {
  //   const { Token: scriptCode, LastRate: lastRateValue, PClose } = data;
  //   if (!scriptCode || lastRateValue === undefined) {
  //     console.warn("Invalid live price update data:", data);
  //     return;
  //   }

  //   const diff = lastRateValue - PClose;
  //   const changePercent = ((diff) / PClose) * 100;

  //   livePriceCache.current[scriptCode] = lastRateValue;
  //   liveDiffCache.current[scriptCode] = diff;
  //   liveChangePercentageCache.current[scriptCode] = changePercent;

  //   setLiveUpdateTrigger((prev) => prev + 1);

  //   console.log(`Live price update - Token: ${scriptCode}, Price: ₹${lastRateValue.toFixed(2)}, Change: ${diff.toFixed(2)} (${changePercent.toFixed(2)}%)`);
  // };



  // Handler for Buy/Sell selection


  // const handleLivePriceUpdate = (data) => {
  //     const { Token: scriptCode, LastRate: lastRateValue, PClose } = data;

  //     if (!scriptCode || lastRateValue === undefined) {
  //         console.warn("Invalid live price update data:", data);
  //         return;
  //     }

  //     const diff = lastRateValue - PClose;
  //     const changePercent = ((diff) / PClose) * 100;

  //     setLivePrices(prev => ({
  //         ...prev,
  //         [scriptCode]: {
  //             price: lastRateValue,
  //             diff: diff,
  //             changePercent: changePercent,
  //             PClose: PClose
  //         }
  //     }));



  //     console.log(`Live price update - Token: ${scriptCode}, Price: ₹${lastRateValue.toFixed(2)}, Change: ${diff.toFixed(2)} (${changePercent.toFixed(2)}%)`);

  // };

  const handleLivePriceUpdate = (data) => {
    const { Token: scriptCode, LastRate: lastRateValue, PClose } = data;

    if (!scriptCode || lastRateValue === undefined) {
      console.warn("Invalid live price update data:", data);
      return;
    }

    const parsedPrice = Number(lastRateValue);
    const parsedPClose = Number(PClose);
    const safePClose = Number.isFinite(parsedPClose) && parsedPClose > 0 ? parsedPClose : 0;
    const diff = parsedPrice - safePClose;
    const changePercent = safePClose > 0 ? (diff / safePClose) * 100 : 0;

    setLivePrices(prev => ({
      ...prev,
      [scriptCode]: {
        price: parsedPrice,
        diff: diff,
        changePercent: changePercent,
        PClose: safePClose
      }
    }));

    console.log(`✅✅Price Update: ${scriptCode} = ₹${parsedPrice.toFixed(2)}`);
  };







  // const handleSelectAction = (stock, action) => {
  //   if (action === 'buy') {
  //     setSelectedBuy(stock);
  //     // Prevent same stock for sell
  //     if (selectedSell === stock.Scripcode) {
  //       setSelectedSell(null);
  //     }
  //   } else {
  //     setSelectedSell(stock);
  //     // Prevent same stock for buy
  //     if (selectedBuy === stock) {
  //       setSelectedBuy(null);
  //     }
  //   }
  // };

  const handleSelectAction = (stock, action) => {
    if (action === 'buy') {
      // If this stock is already selected for Buy, deselect it (toggle off)
      if (selectedBuy?.Scripcode === stock.Scripcode) {
        setSelectedBuy(null);
      } else {
        // Select this stock for Buy
        setSelectedBuy(stock);
        // If this stock was selected for Sell, clear it
        if (selectedSell?.Scripcode === stock.Scripcode) {
          setSelectedSell(null);
        }
      }
    } else if (action === 'sell') {
      // If this stock is already selected for Sell, deselect it (toggle off)
      if (selectedSell?.Scripcode === stock.Scripcode) {
        setSelectedSell(null);
      } else {
        // Select this stock for Sell
        setSelectedSell(stock);
        // If this stock was selected for Buy, clear it
        if (selectedBuy?.Scripcode === stock.Scripcode) {
          setSelectedBuy(null);
        }
      }
    }
  };



  // Add new Rollover
  const handleRolloverSubmit = async () => {
    // ✅ Validation
    if (!selectedBuy || !selectedSell) {
      showErrorToast(tr("pleaseSelectBuySellStocks"));
      return;
    }

    if (!rolloverDifference) {
      showErrorToast(tr("pleaseEnterRolloverDifference"));
      return;
    }

    const parsedDifference = Number(rolloverDifference);
    if (Number.isNaN(parsedDifference)) {
      showErrorToast(tr("pleaseEnterRolloverDifference"));
      return;
    }

    const data = rolloverAdapter.buildAddPayload({
      userId: sharedData?.ID,
      selectedBuy,
      selectedSell,
      difference: parsedDifference,
    });

    try {
      const response = await fetch(
        rolloverAdapter.getAddUrl(),
        {
          method: "POST",
          headers: rolloverAdapter.getHeaders(),
          body: JSON.stringify(data),
        }
      );

      const responseData = await response.json();
      console.log("Rollover Response:", responseData);
      const apiData = rolloverAdapter.normalizeMutationResponse(responseData);

      // ✅ Check response status and show appropriate toast
      if (apiData.status === "success") {
        showSuccessToast(apiData.message || tr("recordInsertedSuccessfully"));

        // ✅ Close modal and reset
        setRolloverDifference(""); // clear input
        setSelectedBuy(null);
        setSelectedSell(null);

        // Refresh data
        setTimeout(() => {
          fetchMCXData(sharedData.ID);
        }, 3000);
      } else {
        // Handle failure response
        showErrorToast(apiData.message || tr("failedToSubmitRollover"));
      }

    } catch (error) {
      console.error("Error submitting rollover:", error);
      showErrorToast(tr("failedToSubmitTryAgain"));
    }
  };





  //----------------------------// END Functions //----------------------------//


  return (
    <>
      <Header />
      <div className="wrapper__page pb-5">
        <Sidebar />

        <div className="content_col">
          {/* Rollover Header */}
          <div className="rollover-header">
            <h1 className="rollover-title">{tr("rollOver")}</h1>
            <div className="rollover-search">
              {/* <div className="search-container">
                <i className="icon-search"></i>
                <input type="text" placeholder="Search (min 3 characters required)" />
              </div> */}





              {/* 
 {isLoading && ( 
  <Placeholder.Grid 
    rows={20} 
    columns={9} 
    active 
    style={{paddingLeft:20, paddingRight:20, paddingTop:12}} 
  /> 
)} */}


              <div ref={containerRef} className="search-container">
                {/* <i className="icon-search"></i> */}
                <input
                  type="text"
                  // placeholder="Search (min 3 characters required)"
                  placeholder={tr("searchCommoditiesRollover")}

                  value={searchTerm}
                  onChange={handleSearchChange}
                  className="search-input"
                />

                {showDropdown && stocks.length > 0 && (
                  <>
                    <div className="search-dropdown" style={{
                      zIndex: "50",
                      borderRadius: '12px',
                      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
                      overflow: 'hidden',
                      backgroundColor: '#FFFFFF',
                      // maxHeight: 'calc(100vh - 250px)',
                      maxHeight: '50vh',
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      {/* Table Container with Scroll */}
                      <div style={{
                        flex: 1,
                        overflowY: 'auto',
                        overflowX: 'hidden'
                      }}>
                        <table style={{
                          width: '100%',
                          borderCollapse: 'collapse'
                        }}>
                          {/* Table Head - Sticky */}
                          <thead style={{
                            backgroundColor: '#f8fafc',
                            position: 'sticky',
                            top: 0,
                            zIndex: 200,
                            borderBottom: '2px solid #e2e8f0'
                          }}>
                            <tr>
                              <th style={{
                                textAlign: 'left',
                                padding: '12px 16px',
                                fontSize: '12px',
                                fontWeight: '700',
                                color: '#64748b',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px'
                              }}>
                                {tr("name")}
                              </th>
                              <th style={{
                                textAlign: 'center',
                                padding: '12px 16px',
                                fontSize: '12px',
                                fontWeight: '700',
                                color: '#64748b',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px'
                              }}>
                                {tr("priceAndChange")}
                              </th>
                              <th style={{
                                textAlign: 'center',
                                padding: '12px 16px',
                                fontSize: '12px',
                                fontWeight: '700',
                                color: '#64748b',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px'
                              }}>
                                {tr("actions")}
                              </th>
                            </tr>
                          </thead>

                          {/* Table Body - Scrollable */}
                          <tbody>
                            {stocks
                              .sort((a, b) => {
                                const priceA = livePrices[a.Scripcode]?.price;
                                const priceB = livePrices[b.Scripcode]?.price;

                                const hasValidPriceA = priceA !== undefined && priceA !== null && priceA > 0;
                                const hasValidPriceB = priceB !== undefined && priceB !== null && priceB > 0;

                                if (hasValidPriceA && !hasValidPriceB) return -1;
                                if (!hasValidPriceA && hasValidPriceB) return 1;
                                return 0;
                              })
                              .map((stock, index) => {
                                const exchange = stock.Exch === 'B' ? 'BSE' : stock.Exch === 'N' ? 'NSE' : 'MCX';
                                const liveData = livePrices[stock.Scripcode] || {};
                                const livePrice = liveData.price;
                                const liveDiff = liveData.diff;
                                const liveChangePercent = liveData.changePercent;

                                const isPriceAvailable = livePrice !== undefined && livePrice !== null && livePrice > 0;
                                const priceColor = liveDiff > 0 ? '#1EA355' : liveDiff < 0 ? '#DC2626' : '#64748b';
                                const arrowIcon = liveDiff > 0 ? 'icon-arrow-up' : 'icon-arrow-down';

                                return (
                                  <tr
                                    key={index}
                                    style={{
                                      borderBottom: '1px solid #e2e8f0',
                                      opacity: isPriceAvailable ? 1 : 0.6,
                                      transition: 'background-color 0.2s ease',
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.backgroundColor = '#f8fafc';
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                  >
                                    {/* Name */}
                                    <td style={{ padding: '12px 16px' }}>
                                      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                        <h5 style={{
                                          fontWeight: '600',
                                          fontSize: '14px',
                                          margin: '0',
                                          color: '#0f172a',
                                          letterSpacing: '-0.1px'
                                        }}>
                                          {stock.Name || stock.FullName}
                                        </h5>
                                        <div style={{
                                          display: 'flex',
                                          gap: '8px',
                                          fontSize: '12px'
                                        }}>
                                          <span style={{
                                            padding: '2px 8px',
                                            backgroundColor: '#f1f5f9',
                                            borderRadius: '4px',
                                            fontWeight: '500',
                                            color: '#64748b'
                                          }}>
                                            {exchange}
                                          </span>
                                          <span style={{
                                            padding: '2px 8px',
                                            backgroundColor: '#f1f5f9',
                                            borderRadius: '4px',
                                            fontWeight: '500',
                                            color: '#64748b'
                                          }}>
                                            {stock.FullName}
                                          </span>
                                        </div>
                                      </div>
                                    </td>

                                    {/* Price & Change */}
                                    <td style={{
                                      textAlign: 'center',
                                      padding: '12px 16px',
                                      color: isPriceAvailable ? priceColor : '#64748b'
                                    }}>
                                      <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: '2px'
                                      }}>
                                        {isPriceAvailable ? (
                                          <>
                                            {/* Current Price */}
                                            <div style={{
                                              fontSize: '15px',
                                              fontWeight: '700',
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              gap: '4px'
                                            }}>
                                              ₹{formatNumber(livePrice.toFixed(2))}
                                              {liveDiff !== undefined && liveDiff !== null && (
                                                <i className={arrowIcon} style={{ fontSize: '12px' }}></i>
                                              )}
                                            </div>

                                            {/* Separator */}
                                            <div style={{
                                              width: '20px',
                                              height: '1px',
                                              background: 'linear-gradient(90deg, transparent, #cbd5e1, transparent)',
                                              opacity: '0.3',
                                              margin: '1px 0'
                                            }}></div>

                                            {/* Net Change */}
                                            <div style={{
                                              fontSize: '12px',
                                              fontWeight: '600'
                                            }}>
                                              {liveDiff !== undefined && liveDiff !== null && liveChangePercent !== undefined && liveChangePercent !== null
                                                ? `${formatNumber(liveDiff.toFixed(2))} (${liveChangePercent.toFixed(2)}%)`
                                                : '—'}
                                            </div>
                                          </>
                                        ) : (
                                          <span style={{ fontSize: '12px', fontWeight: '500' }}>{tr("unavailable")}</span>
                                        )}
                                      </div>
                                    </td>

                                    {/* Action Buttons */}
                                    <td style={{ textAlign: 'center', padding: '12px 16px' }}>
                                      <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
                                        {/* Buy Button */}
                                        <button
                                          style={{
                                            padding: '6px 14px',
                                            borderRadius: '8px',
                                            border: selectedBuy?.Scripcode === stock.Scripcode ? 'none' : '1px solid #e2e8f0',
                                            fontWeight: '600',
                                            fontSize: '12px',
                                            letterSpacing: '0.3px',
                                            backgroundColor: selectedBuy?.Scripcode === stock.Scripcode ? '#1EA355' : '#f1f5f9',
                                            color: selectedBuy?.Scripcode === stock.Scripcode ? 'white' : '#0f172a',
                                            cursor: selectedSell?.Scripcode === stock.Scripcode ? 'not-allowed' : 'pointer',
                                            pointerEvents: selectedSell?.Scripcode === stock.Scripcode ? 'none' : 'auto',
                                            boxShadow: selectedBuy?.Scripcode === stock.Scripcode ? '0 4px 12px rgba(30, 163, 85, 0.3)' : 'none',
                                            transition: 'all 0.2s ease',
                                            opacity: selectedSell?.Scripcode === stock.Scripcode ? 0.5 : 1,
                                          }}
                                          onClick={() => handleSelectAction(stock, 'buy')}
                                          disabled={selectedSell?.Scripcode === stock.Scripcode}
                                          onMouseEnter={(e) => {
                                            if (selectedBuy?.Scripcode !== stock.Scripcode && selectedSell?.Scripcode !== stock.Scripcode) {
                                              e.currentTarget.style.backgroundColor = '#eff8f5';
                                              e.currentTarget.style.borderColor = '#1EA355';
                                              e.currentTarget.style.color = '#1EA355';
                                            }
                                          }}
                                          onMouseLeave={(e) => {
                                            if (selectedBuy?.Scripcode !== stock.Scripcode && selectedSell?.Scripcode !== stock.Scripcode) {
                                              e.currentTarget.style.backgroundColor = '#f1f5f9';
                                              e.currentTarget.style.borderColor = '#e2e8f0';
                                              e.currentTarget.style.color = '#0f172a';
                                            }
                                          }}
                                        >
                                          {tr("buy")}
                                        </button>

                                        {/* Sell Button */}
                                        <button
                                          style={{
                                            padding: '6px 14px',
                                            borderRadius: '8px',
                                            border: selectedSell?.Scripcode === stock.Scripcode ? 'none' : '1px solid #e2e8f0',
                                            fontWeight: '600',
                                            fontSize: '12px',
                                            letterSpacing: '0.3px',
                                            backgroundColor: selectedSell?.Scripcode === stock.Scripcode ? '#DC2626' : '#f1f5f9',
                                            color: selectedSell?.Scripcode === stock.Scripcode ? 'white' : '#0f172a',
                                            cursor: selectedBuy?.Scripcode === stock.Scripcode ? 'not-allowed' : 'pointer',
                                            pointerEvents: selectedBuy?.Scripcode === stock.Scripcode ? 'none' : 'auto',
                                            boxShadow: selectedSell?.Scripcode === stock.Scripcode ? '0 4px 12px rgba(220, 38, 38, 0.3)' : 'none',
                                            transition: 'all 0.2s ease',
                                            opacity: selectedBuy?.Scripcode === stock.Scripcode ? 0.5 : 1,
                                          }}
                                          onClick={() => handleSelectAction(stock, 'sell')}
                                          disabled={selectedBuy?.Scripcode === stock.Scripcode}
                                          onMouseEnter={(e) => {
                                            if (selectedSell?.Scripcode !== stock.Scripcode && selectedBuy?.Scripcode !== stock.Scripcode) {
                                              e.currentTarget.style.backgroundColor = '#fef2f2';
                                              e.currentTarget.style.borderColor = '#DC2626';
                                              e.currentTarget.style.color = '#DC2626';
                                            }
                                          }}
                                          onMouseLeave={(e) => {
                                            if (selectedSell?.Scripcode !== stock.Scripcode && selectedBuy?.Scripcode !== stock.Scripcode) {
                                              e.currentTarget.style.backgroundColor = '#f1f5f9';
                                              e.currentTarget.style.borderColor = '#e2e8f0';
                                              e.currentTarget.style.color = '#0f172a';
                                            }
                                          }}
                                        >
                                          {tr("sell")}
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>

                      {/* Fixed Footer */}
                      <div style={{
                        minHeight: '100px',
                        backgroundColor: '#FFFFFF',
                        borderTop: '1px solid #e2e8f0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '20px 24px',
                        boxShadow: '0 -2px 12px rgba(0, 0, 0, 0.05)',
                        userSelect: 'none',
                        flexShrink: 0
                      }}>
                        {/* Selected Stocks Display */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                          <div style={{
                            fontSize: '11px',
                            fontWeight: '700',
                            color: '#64748b',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            {tr("selectedStocks")}
                          </div>

                          <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px',
                            fontSize: '13px',
                            fontWeight: '500',
                          }}>
                            {/* Buy */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#1EA355' }}>
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M8 3V13M8 3L4 7M8 3L12 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                              <span>{tr("buy")}:</span>
                              <span style={{ fontWeight: '600', color: '#0f172a' }}>
                                {selectedBuy ? `${selectedBuy.Name} (${selectedBuy.FullName})` : tr("noStockSelectedBracket")}
                              </span>
                            </div>

                            {/* Sell */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#DC2626' }}>
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M8 13V3M8 13L4 9M8 13L12 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                              <span>{tr("sell")}:</span>
                              <span style={{ fontWeight: '600', color: '#0f172a' }}>
                                {selectedSell ? `${selectedSell.Name} (${selectedSell.FullName})` : tr("noStockSelectedBracket")}
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Submit Button */}
                        <button
                          disabled={!selectedBuy || !selectedSell || selectedBuy?.Scripcode === selectedSell?.Scripcode}
                          onClick={() => {
                            console.log('Submit Buy:', selectedBuy, 'Sell:', selectedSell);
                          }}
                          data-bs-toggle="modal"
                          data-bs-target="#RollOverDifference"
                          style={{
                            padding: '12px 32px',
                            background:
                              !selectedBuy || !selectedSell || selectedBuy?.Scripcode === selectedSell?.Scripcode
                                ? 'linear-gradient(135deg, #cbd5e1, #b8c5d6)'
                                : 'linear-gradient(135deg, #2457BF 0%, #1a42a0 100%)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '10px',
                            cursor:
                              !selectedBuy || !selectedSell || selectedBuy?.Scripcode === selectedSell?.Scripcode
                                ? 'not-allowed'
                                : 'pointer',
                            fontWeight: '700',
                            fontSize: '14px',
                            letterSpacing: '0.3px',
                            boxShadow:
                              !selectedBuy || !selectedSell || selectedBuy?.Scripcode === selectedSell?.Scripcode
                                ? 'none'
                                : '0 4px 12px rgba(36, 87, 191, 0.3)',
                            transition: 'all 0.2s ease',
                          }}
                          onMouseOver={(e) => {
                            if (!e.currentTarget.disabled) {
                              e.currentTarget.style.background = 'linear-gradient(135deg, #1a42a0 0%, #152d7a 100%)';
                              e.currentTarget.style.boxShadow = '0 8px 24px rgba(36, 87, 191, 0.4)';
                              e.currentTarget.style.transform = 'translateY(-2px)';
                            }
                          }}
                          onMouseOut={(e) => {
                            if (!e.currentTarget.disabled) {
                              e.currentTarget.style.background = 'linear-gradient(135deg, #2457BF 0%, #1a42a0 100%)';
                              e.currentTarget.style.boxShadow = '0 4px 12px rgba(36, 87, 191, 0.3)';
                              e.currentTarget.style.transform = 'translateY(0)';
                            }
                          }}
                        >
                          {tr("configureRollover")}
                        </button>
                      </div>
                    </div>
                  </>
                )}


              </div>


              <div className="rollover-view-toggle" role="group" aria-label="View mode">
                <button
                  type="button"
                  className={`rollover-view-btn ${viewMode === "grid" ? "active" : ""}`}
                  onClick={() => setViewMode("grid")}
                  title="Grid view"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <rect x="2" y="2" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5" />
                    <rect x="9" y="2" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5" />
                    <rect x="2" y="9" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5" />
                    <rect x="9" y="9" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5" />
                  </svg>
                </button>
                <button
                  type="button"
                  className={`rollover-view-btn ${viewMode === "list" ? "active" : ""}`}
                  onClick={() => setViewMode("list")}
                  title="List view"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <line x1="3" y1="4" x2="13" y2="4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    <line x1="3" y1="8" x2="13" y2="8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    <line x1="3" y1="12" x2="13" y2="12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* Rollover Content */}
          {/* Rollover Content */}
          <div>
            <div>
              <div className={`rollover-content ${viewMode === "list" ? "list-view" : "grid-view"}`}>
                {isLoading ? (
                  <div style={{ padding: '10px 20px' }}>
                    {/* Simulate 3 rollover rows */}
                    {[1, 2, 3].map((_, index) => (
                      <div
                        key={index}
                        style={{
                          display: 'flex',
                          gap: '20px',
                          marginBottom: '24px',
                          padding: '5px',
                          backgroundColor: '#ffffff',
                          borderRadius: '12px',
                          border: '1px solid #e8ecef',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                        }}
                      >
                        {/* First Card Skeleton */}
                        <div style={{ flex: 1 }}>
                          <Placeholder.Paragraph
                            rows={4}
                            rowHeight={10}
                            rowMargin={15}
                            active
                            style={{ padding: '5px', marginTop: "15px" }}
                          />
                        </div>

                        {/* Second Card Skeleton */}
                        <div style={{ flex: 1 }}>
                          <Placeholder.Paragraph
                            rows={4}
                            rowHeight={10}
                            rowMargin={15}
                            active
                            style={{ padding: '5px', marginTop: "15px" }}
                          />
                        </div>

                        {/* Difference Card Skeleton */}
                        <div style={{ flex: 1 }}>
                          <Placeholder.Paragraph
                            rows={4}
                            rowHeight={10}
                            rowMargin={15}
                            active
                            style={{ padding: '10px', marginTop: "15px" }}
                          />
                        </div>

                        {/* Delete Button Skeleton */}
                        <div style={{ width: '40px', display: 'flex', alignItems: 'center' }}>
                          <Placeholder.Graph
                            width={40}
                            height={40}
                            active
                            style={{ borderRadius: '8px' }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : commodity.length === 0 ? (
                  // Empty state - No commodities
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '500px',
                    padding: '40px 20px'
                  }}>
                    <div style={{
                      backgroundColor: '#ffffff',
                      borderRadius: '16px',
                      padding: '60px 50px',
                      maxWidth: '560px',
                      width: '100%',
                      textAlign: 'center',
                      boxShadow: '0 10px 40px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.06)',
                      border: '1px solid #e8ecef'
                    }}>
                      {/* Icon */}
                      <div style={{
                        width: '80px',
                        height: '80px',
                        margin: '0 auto 32px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '2px solid #e9ecef'
                      }}>
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M3 3v18h18" />
                          <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3" />
                        </svg>
                      </div>

                      {/* Heading */}
                      <h3 style={{
                        fontSize: '28px',
                        fontWeight: '600',
                        color: '#1a1a1a',
                        marginBottom: '16px',
                        letterSpacing: '-0.5px'
                      }}>
                        {tr("noRolloverPairs")}
                      </h3>

                      {/* Description */}
                      <p style={{
                        fontSize: '16px',
                        color: '#6c757d',
                        lineHeight: '1.7',
                        maxWidth: '440px',
                        margin: '0 auto'
                      }}>
                        {tr("rolloverPairsDescription")}
                      </p>

                      {/* Divider */}
                      <div style={{
                        width: '60px',
                        height: '1px',
                        backgroundColor: '#dee2e6',
                        margin: '32px auto'
                      }}></div>

                      {/* Helper text */}
                      <p style={{
                        fontSize: '14px',
                        color: '#adb5bd',
                        fontWeight: '500',
                        letterSpacing: '0.3px'
                      }}>
                        {tr("useSearchBarForRollover")}
                      </p>
                    </div>
                  </div>
                ) : viewMode === "list" ? (
                  <div className="rollover-list-table-wrap">
                    <table className="rollover-list-table">
                      <thead>
                        <tr>
                          <th>{tr("sell")}</th>
                          <th>{tr("buy")}</th>
                          <th>{tr("differenceUpper")}</th>
                          <th>{tr("currentUpper")}</th>
                          <th>{tr("actions")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {commodity.map((item, index) => {
                          const liveData1 = livePrices[Number(item.scripcode_1)] || {};
                          const liveData2 = livePrices[Number(item.scripcode_2)] || {};
                          const liveDiff1 = liveData1.diff ?? 0;
                          const liveDiff2 = liveData2.diff ?? 0;
                          const livePrice1 = liveData1.price ?? 0;
                          const livePrice2 = liveData2.price ?? 0;
                          const isNotified = item.isNotified === "1";
                          const isDisabled = !(livePrice1 > 0 && livePrice2 > 0);
                          const currentDiff = computeCurrentDifference(item) ?? "0.00";

                          return (
                            <tr
                              key={index}
                              className={`${isNotified ? "is-notified" : ""} ${isDisabled ? "execute_disable" : ""}`}
                            >
                              <td>
                                <div className="list-entity-cell">
                                  <div className="list-symbol">{item.symbol_2}</div>
                                  <div className="list-name">{item.name_2}</div>
                                  <div className={`list-price ${liveDiff2 >= 0 ? "up" : "down"}`}>
                                    ₹{formatNumber(livePrice2?.toFixed(2)) ?? "0.00"}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="list-entity-cell">
                                  <div className="list-symbol">{item.symbol_1}</div>
                                  <div className="list-name">{item.name_1}</div>
                                  <div className={`list-price ${liveDiff1 >= 0 ? "up" : "down"}`}>
                                    ₹{formatNumber(livePrice1?.toFixed(2)) ?? "0.00"}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="list-diff-cell">
                                  <span className="list-diff-value">₹{item.difference}</span>
                                  <button
                                    className="btn_edit_rollover"
                                    onClick={() => {
                                      handleEditDifference(item);
                                    }}
                                    data-bs-toggle="modal"
                                    data-bs-target="#UpdateDifferenceModal"
                                  >
                                    <img src={IconEdit} alt="Edit" />
                                  </button>
                                </div>
                              </td>
                              <td>
                                <div className="list-current-value">₹{currentDiff}</div> <br />
                                {isNotified && (
                                  <span className="list-notified-pill">
                                    <span className="list-notified-pill-icon">✓</span>
                                    {tr("notified")}
                                  </span>
                                )}
                              </td>
                              <td>
                                <div className="list-action-cell">
                                  <button
                                    className="remove-row-btn"
                                    title={tr("removeRow")}
                                    onClick={() => setTruncateOrderId(item.id)}
                                    data-bs-toggle="modal"
                                    data-bs-target="#DeleteConfirmationModal"
                                  >
                                    <i className="icon-delete"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  // Display commodity cards
                  commodity.map((item, index) => {
                    // Get live data for each scripcode
                    const liveData1 = livePrices[Number(item.scripcode_1)] || {};
                    const liveData2 = livePrices[Number(item.scripcode_2)] || {};

                    // Get live differences for each scripcode
                    const liveDiff1 = liveData1.diff ?? 0;
                    const liveDiff2 = liveData2.diff ?? 0;

                    // Get live prices
                    const livePrice1 = liveData1.price ?? 0;
                    const livePrice2 = liveData2.price ?? 0;

                    const isNotified = item.isNotified === "1";
                    const isDisabled = !(livePrice1 > 0 && livePrice2 > 0);

                    return (
                      <div
                        className={`rollover-row ${isNotified ? "is-notified" : ""} ${isDisabled ? "execute_disable" : ""}`}
                        key={index}
                      >
                        {/* Notification Badge */}
                        {isNotified && (
                          <div className="rollover-notified-badge" title={tr("notified")}>
                            <span className="rollover-notified-icon">✓</span>
                            <span>{tr("notified")}</span>
                          </div>
                        )}

                        {/* First Card: Sell */}
                        <div className={`rollover-card ${isNotified ? "is-notified" : ""}`}>
                          <div className="card-header">
                            <h3 className="card-title">{item.name_2}</h3>
                            <div className="card-subtitle">{item.symbol_2}</div>
                          </div>
                          <div className="card-body">
                            <div className="position-info">
                              <span className={`position-badge ${item.buy_sell_2.toLowerCase()}`}>
                                {item.buy_sell_2}
                              </span>
                              <div className="price-display">
                                <span
                                  style={{
                                    color: liveDiff2 >= 0 ? "#16a34a" : "red",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  ₹{formatNumber(livePrice2?.toFixed(2)) ?? "0.00"}
                                  <span style={{ marginLeft: 6 }}>
                                    {liveDiff2 >= 0 ? (
                                      <ArrowTrendUp width={16} height={16} />
                                    ) : (
                                      <ArrowTrendDown width={16} height={16} />
                                    )}
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Second Card: Buy */}
                        <div className={`rollover-card ${isNotified ? "is-notified" : ""}`}>
                          <div className="card-header">
                            <h3 className="card-title">{item.name_1}</h3>
                            <div className="card-subtitle">{item.symbol_1}</div>
                          </div>
                          <div className="card-body">
                            <div className="position-info">
                              <span className={`position-badge ${item.buy_sell_1.toLowerCase()}`}>
                                {item.buy_sell_1}
                              </span>
                              <div className="price-display">
                                <span
                                  style={{
                                    color: liveDiff1 >= 0 ? "#16a34a" : "red",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  ₹{formatNumber(livePrice1?.toFixed(2)) ?? "0.00"}
                                  <span style={{ marginLeft: 6 }}>
                                    {liveDiff1 >= 0 ? (
                                      <ArrowTrendUp width={16} height={16} />
                                    ) : (
                                      <ArrowTrendDown width={16} height={16} />
                                    )}
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Difference Card */}
                        <div className={`rollover-card difference-card ${isNotified ? "is-notified" : ""}`}>
                          <div className="card-header">
                            <div className="difference-header-item">
                              <h3 className="card-title">{tr("differenceUpper")}</h3>
                              <div className="difference-value">
                                <span className="value">₹{item.difference}</span>
                                <button
                                  className="btn_edit_rollover"
                                  onClick={() => {
                                    handleEditDifference(item);
                                  }}
                                  data-bs-toggle="modal"
                                  data-bs-target="#UpdateDifferenceModal"
                                >
                                  <img src={IconEdit} alt="Edit" />
                                </button>
                              </div>
                            </div>
                            <div className="difference-header-item">
                              <h3 className="card-title">{tr("currentUpper")}</h3>
                              <div className="current-value" style={{ color: "#16a34a" }}>
                                ₹
                                {livePrice1 > 0 && livePrice2 > 0
                                  ? formatNumber((livePrice1 - livePrice2).toFixed(2))
                                  : "0.00"}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Remove Row Button */}
                        <div className="row-remove-btn">
                          <button
                            className="remove-row-btn"
                            title={tr("removeRow")}
                            onClick={() => setTruncateOrderId(item.id)}
                            data-bs-toggle="modal"
                            data-bs-target="#DeleteConfirmationModal"
                          >
                            <i className="icon-delete"></i>
                          </button>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>











        </div>
      </div>




      {/* RollOver Difference Modal - Clean Modern */}
      <div
        className="modal fade"
        id="RollOverDifference"
        aria-labelledby="RollOverDifferenceLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "450px" }}>
          <div
            className="modal-content border-0"
            style={{
              borderRadius: "16px",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.12)",
              overflow: "hidden",
              backgroundColor: "#FFFFFF"
            }}
          >
            {/* Simple Header */}
            <div
              style={{
                padding: "1.25rem 1.5rem",
                backgroundColor: "#FFFFFF",
                borderBottom: "1px solid #f1f5f9"
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h5
                  id="RollOverDifferenceLabel"
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    margin: 0,
                    color: "#0f172a"
                  }}
                >
                  {tr("priceDifference")}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label={tr("close")}
                  style={{ opacity: 0.5 }}
                ></button>
              </div>
            </div>

            {/* Body */}
            <div style={{ padding: "1.5rem" }}>
              {/* Stock Info - Simple Layout */}
              <div style={{ marginBottom: '1.5rem' }}>
                {/* Buy */}
                <div style={{ marginBottom: '1rem' }}>
                  <div style={{
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#64748b',
                    textTransform: 'uppercase',
                    letterSpacing: '0.3px',
                    marginBottom: '0.4rem'
                  }}>
                    {tr("buy")}
                  </div>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: '700',
                    color: '#1EA355',
                    marginBottom: '2px'
                  }}>
                    {selectedBuy ? selectedBuy.Name : '—'}
                  </div>
                  <div style={{
                    fontSize: '12px',
                    fontWeight: '500',
                    color: '#64748b'
                  }}>
                    {selectedBuy ? selectedBuy.FullName : tr("noStockSelected")}
                  </div>
                </div>

                {/* Divider */}
                <div style={{
                  height: '1px',
                  background: '#f1f5f9',
                  margin: '1rem 0'
                }}></div>

                {/* Sell */}
                <div>
                  <div style={{
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#64748b',
                    textTransform: 'uppercase',
                    letterSpacing: '0.3px',
                    marginBottom: '0.4rem'
                  }}>
                    {tr("sell")}
                  </div>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: '700',
                    color: '#DC2626',
                    marginBottom: '2px'
                  }}>
                    {selectedSell ? selectedSell.Name : '—'}
                  </div>
                  <div style={{
                    fontSize: '12px',
                    fontWeight: '500',
                    color: '#64748b'
                  }}>
                    {selectedSell ? selectedSell.FullName : tr("noStockSelected")}
                  </div>
                </div>
              </div>

              {/* Input Section */}
              <div style={{ marginBottom: '1.5rem' }}>
                <label
                  htmlFor="rolloverDifferenceInput"
                  style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: '600',
                    fontSize: '13px',
                    color: '#0f172a'
                  }}
                >
                  {tr("maximumDifference")}
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="rolloverDifferenceInput"
                  placeholder={tr("zeroAmountPlaceholder")}
                  value={rolloverDifference}
                  onChange={(e) => setRolloverDifference(Number(e.target.value))}
                  style={{
                    borderRadius: '8px',
                    padding: '10px 12px',
                    border: '1px solid #e2e8f0',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#0f172a',
                    transition: 'all 0.2s ease',
                    width: '100%',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#2457BF';
                    e.target.style.outline = 'none';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e2e8f0';
                  }}
                />
              </div>

              {/* Buttons */}
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  style={{
                    padding: '10px 18px',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0',
                    background: '#ffffff',
                    color: '#0f172a',
                    fontWeight: '600',
                    fontSize: '13px',
                    cursor: 'pointer',
                    transition: 'all 0.15s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#f8fafc';
                    e.target.style.borderColor = '#cbd5e1';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#ffffff';
                    e.target.style.borderColor = '#e2e8f0';
                  }}
                >
                  {tr("cancel")}
                </button>
                <button
                  disabled={!selectedBuy || !selectedSell || !rolloverDifference}
                  onClick={() => {
                    handleRolloverSubmit();
                  }}
                  data-bs-dismiss="modal"
                  style={{
                    padding: '10px 24px',
                    borderRadius: '8px',
                    border: 'none',
                    background: (!selectedBuy || !selectedSell || !rolloverDifference)
                      ? '#cbd5e1'
                      : '#2457BF',
                    color: '#fff',
                    fontWeight: '600',
                    fontSize: '13px',
                    cursor: (!selectedBuy || !selectedSell || !rolloverDifference) ? 'not-allowed' : 'pointer',
                    transition: 'all 0.15s ease'
                  }}
                  onMouseEnter={(e) => {
                    if (!e.currentTarget.disabled) {
                      e.currentTarget.style.background = '#1a42a0';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!e.currentTarget.disabled) {
                      e.currentTarget.style.background = '#2457BF';
                    }
                  }}
                >
                  {tr("confirm")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>



      {/* RollOver Difference Updating Modal */}
      <div
        className="modal fade"
        id="UpdateDifferenceModal"
        aria-labelledby="UpdateDifferenceModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered rollover-modal-dialog">
          <div className="modal-content border-0 rollover-modal-content">
            <div className="rollover-modal-header">
              <div>
                <h5 className="mb-0 rollover-modal-title" id="UpdateDifferenceModalLabel">
                  {tr("updateDifference")}
                </h5>
                <p className="rollover-modal-subtitle">
                  {tr("enterPriceDifferenceHint")}
                </p>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label={tr("close")}
              ></button>
            </div>

            <div className="rollover-modal-body">
              <div className="rollover-pair-card">
                <div className="rollover-pair-side">
                  <span className="rollover-chip buy">{tr("buy")}</span>
                  <div className="rollover-pair-name">{editingItem?.name_2 || "-"}</div>
                  <div className="rollover-pair-symbol">{editingItem?.symbol_2 || "-"}</div>
                </div>

                <div className="rollover-pair-separator" aria-hidden="true">
                  →
                </div>

                <div className="rollover-pair-side align-end">
                  <span className="rollover-chip sell">{tr("sell")}</span>
                  <div className="rollover-pair-name">{editingItem?.name_1 || "-"}</div>
                  <div className="rollover-pair-symbol">{editingItem?.symbol_1 || "-"}</div>
                </div>
              </div>

              <div className="rollover-form-group">
                <label htmlFor="updateDifferenceInput" className="rollover-input-label">
                  {tr("differenceAmount")}
                </label>
                <input
                  type="number"
                  className="form-control rollover-input"
                  id="updateDifferenceInput"
                  placeholder={tr("enterNewDifference")}
                  value={updatedDifference}
                  onChange={(e) => setUpdatedDifference(e.target.value)}
                  inputMode="decimal"
                />
              </div>

              <div className="rollover-modal-actions">
                <button
                  type="button"
                  className="btn rollover-btn secondary"
                  data-bs-dismiss="modal"
                >
                  {tr("cancel")}
                </button>
                <button
                  className="btn rollover-btn primary"
                  disabled={!updatedDifference || !editingItem}
                  onClick={handleUpdateDifference}
                >
                  {tr("update")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>




      {/* Delete Confirmation Modal */}
      <div
        className="modal fade"
        id="DeleteConfirmationModal"
        aria-labelledby="DeleteConfirmationLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered rollover-delete-dialog">
          <div className="modal-content border-0 rollover-delete-content">
            <div className="rollover-delete-header">
              <div className="rollover-delete-icon" aria-hidden="true">!</div>
              <h5 id="DeleteConfirmationLabel" className="rollover-delete-title">
                {tr("deleteOrder")}
              </h5>
              <p className="rollover-delete-subtitle">
                {tr("deleteOrderConfirmation").replace(" This cannot be undone.", ".\nThis cannot be undone.")}
              </p>
            </div>

            <div className="rollover-delete-actions">
              <button
                type="button"
                data-bs-dismiss="modal"
                className="btn rollover-btn secondary"
              >
                {tr("keep")}
              </button>
              <button
                className="btn rollover-btn danger"
                onClick={() => {
                  handleTruncateOrder(truncateOrderId);
                }}
                data-bs-dismiss="modal"
              >
                {tr("delete")}
              </button>
            </div>
          </div>
        </div>
      </div>





    </>
  );
}

export default Rollover;
